import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import InventorySubTable2 from "./InventorySubTable2";
import { useState } from "react";
import ButtonSpinner from "../../../components/controls/ButtonSpinner";
import CopyableIdentifier from "../../../components/controls/CopyableIdentifier";

export default function InventorySubTable1(props) {
  const {
    data,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    selectedItems,
    setSelectedItems,
    openAdjustPriceModal,
    adjustInProgress,
    openSlideForManufacturedItemDetails,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const lotNumberBody = (item) => (
    <CopyableIdentifier value={item.lot_number} description="lot number" />
  );

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!subRowDetails[rowData.unique_id]) {
      fetchSubRowDetails(rowData);
    }
  };

  const allowExpansion = (rowData) => {
    return true;
  };

  function rowExpansionTemplate(data) {
    return (
      <InventorySubTable2
        data={data}
        loadingRows={subLoadingRows}
        rowDetails={subRowDetails}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        openSlideForManufacturedItemDetails={
          openSlideForManufacturedItemDetails
        }
      />
    );
  }

  const bodyProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const parentTotalCartons = (item) => {
    return <p>{item.total_cartons} cartons</p>;
  };

  const bodyParentTotalWeight = (item) => {
    return (
      <p>
        {item.total_weight_in_kg} kg <br />
        {item.total_weight_in_lbs} lbs
      </p>
    );
  };

  const bodyParentTotalPieces = (item) => {
    return <p>{item.total_pieces} pieces</p>;
  };

  const moreActions = (item) => {
    return (
      <button
        onClick={() => {
          openAdjustPriceModal(item);
        }}
        className="ml-5 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <ButtonSpinner spin={adjustInProgress} text="Adjust price" />
      </button>
    );
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        onRowExpand={onRowExpand}
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="unique_id"
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm inventory-sub-items-table"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm inv-sub-item"
      >
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "20%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ width: "10%" }}
        />
        <Column
          header="Carton Count"
          body={parentTotalCartons}
          style={{ width: "8%", textAlign: "right" }}
        />
        <Column
          header="Total Weight"
          body={bodyParentTotalWeight}
          style={{ width: "8%", textAlign: "right" }}
        />
        <Column
          header="Total Pieces"
          body={bodyParentTotalPieces}
          style={{ width: "8%", textAlign: "right" }}
        />
        {/* {selectedItems.length > 0 ? (
          <Column
            header=""
            body={moreActions}
            style={{ width: "8%", textAlign: "right" }}
          />
        ) : null} */}
        <Column expander={allowExpansion} style={{ width: "6%" }} />
      </DataTable>
    </div>
  );
}
